import React from 'react';

// accent: 'conversas' | 'custo' | undefined -> colore o valor conforme a métrica.
const KPICard = ({ label, value, sublabel, small, accent }) => {
  const valueClass = accent ? `kpi-value kpi-value--${accent}` : 'kpi-value';
  return (
    <div className={small ? 'kpi-card kpi-card--small' : 'kpi-card'}>
      <div className="kpi-label">{label}</div>
      <div className={valueClass}>{value}</div>
      {sublabel && <div className="kpi-sublabel">{sublabel}</div>}
    </div>
  );
};

export default KPICard;
